import { BackendId } from "@libs/appliance_common";
const now = new Date();
const mockUserId = "11111111-1111-1111-1111-111111111111";
export let apiKeys = [
    {
        id: "a1a1a1a1-b2b2-c3c3-d4d4-e5e5e5e5e5e5",
        name: "My First Key",
        user_id: mockUserId,
        user_backend: BackendId.Local,
        created_at: new Date(now.getTime() - 1000 * 60 * 60 * 24 * 7).toISOString(),
        expires_at: new Date(now.getTime() + 1000 * 60 * 60 * 24 * 30).toISOString(),
        username: "mockuser",
        scopes: [
            "entropy",
            "blast"
        ]
    },
    {
        id: "f6f6f6f6-g7g7-h8h8-i9i9-j0j0j0j0j0j0",
        name: "Another Key",
        user_id: mockUserId,
        user_backend: BackendId.Local,
        created_at: new Date(now.getTime() - 1000 * 60 * 60 * 24 * 2).toISOString(),
        expires_at: new Date(now.getTime() + 1000 * 60 * 60 * 24 * 90).toISOString(),
        username: "mockuser",
        scopes: [
            "entropy",
            "blast"
        ]
    }
];
export default apiKeys;
